import React, { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import { NavLink } from "react-router-dom";
import TeacherMenu from "./TeacherMenu";
import config from "../../Config";

function TeacherEvents() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    document.title = "School Events - Teacher";
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/GetEventsForStaffDashboard",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Teacher",
        pageNo: 1,
        pageSize: 100,
      },
    })
      .then((res) => setEvents(res.data.ListofRecords || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <TeacherMenu />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><NavLink to="/teacher/dashboard">Home</NavLink></li>
                    <li className="breadcrumb-item active">School Events</li>
                  </ol>
                </nav>
                <div className="page-title">School Events</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container body-content">
        <div className="card">
          <div className="card-body">
            {loading ? (
              <Spinner animation="border" />
            ) : events.length === 0 ? (
              <p className="text-muted mb-0">No approved events available right now.</p>
            ) : (
              <ul className="list-group list-group-flush">
                {events.map((e) => (
                  <li key={e.ID} className="list-group-item px-0">
                    {e.TitleImage ? (
                      <img
                        src={`${config.root}SchoolEvents/${e.TitleImage}`}
                        alt=""
                        className="mb-2"
                        style={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 8 }}
                      />
                    ) : null}
                    <h6 className="mb-1">{e.EventTitle}</h6>
                    <p className="mb-1 small text-muted">
                      {moment(e.StartDate).format("DD MMM YYYY, hh:mm A")} - {moment(e.EndDate).format("DD MMM YYYY, hh:mm A")}
                    </p>
                    {e.LocationAddress && <p className="mb-1 small">Location: {e.LocationAddress}</p>}
                    {e.EventDetails && <p className="mb-0">{e.EventDetails}</p>}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default TeacherEvents;
